import axios from '../axios'

export const findPage = (data) => {
  return axios({
      url: '/cronjob/findPage',
      method: 'post',
      data
  })
}
export const add = (data) => {
  return axios({
      url: '/cronjob/add',
      method: 'post',
      data
  })
}
export const start = (id) => {
  return axios({
      url: '/cronjob/start/'+id,
      method: 'get'
  })
}
export const pause = (id) => {
  return axios({
      url: '/cronjob/pause/'+id,
      method: 'get'
  })
}
export const del = (id) => {
  return axios({
      url: '/cronjob/delete/'+id,
      method: 'get'
  })
}
export const startAll = (data) => {
  return axios({
      url: '/cronjob/startAllJob',
      method: 'get',
      data
  })
}
export const pauseAll = (data) => {
  return axios({
      url: '/cronjob/pauseAllJob',
      method: 'get',
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/cronjob.js